const sendCode = (email) => {
  return window.axios.post("/otp-request", { email });
};

export default (initialEmail = "") => ({
  email: initialEmail,
  emailSubmitted: initialEmail.length > 0,
  resent: false,
  errorMessage: null,
  loading: false,
  reset() {
    this.email = "";
    this.emailSubmitted = false;
    this.errorMessage = null;
    this.resent = false;
    this.loading = false;
  },
  resend() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    sendCode(this.email)
      .then(() => {
        this.resent = true;
        this.loading = false;
      })
      .catch(({ response }) => {
        this.loading = false;
        this.handleError(response);
      });
  },
  handleError(response) {
    if (
      response.status == 422 &&
      typeof response.data.errors != "undefined" &&
      typeof response.data.errors.email != "undefined" &&
      typeof response.data.errors.email.length
    ) {
      this.errorMessage = response.data.errors.email[0];
    } else {
      this.errorMessage =
        "We're sorry, there was a problem requesting an one-time passcode. Please try again later.";
    }
  },
  submit(e) {
    if (this.emailSubmitted || this.loading) {
      return;
    }
    this.loading = true;
    e.preventDefault();
    sendCode(this.email)
      .then(() => {
        this.emailSubmitted = true;
        this.loading = false;
      })
      .catch(({ response }) => {
        this.loading = false;
        this.handleError(response);
      });
  },
});
